import { Stack } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { pageTabHeaderTypographyProps } from "@/App/Layouts/PageBody/PageTabHeader";
import { ViewVariant } from "@/common/ts/layout";
import { ContractDto } from "@/core/api/generated/v1";

import AssetSubscriptionView from "../../../AssetSubscription/View/AssetSubscriptionView";

interface Props {
  contract: ContractDto;
}

export default function AssetSubscriptionTabContent({ contract }: Props) {
  return (
    <PageTabContent>
      <Stack direction='column' spacing={2}>
        <AssetSubscriptionView
          assetSubscriptionId={contract.assetSubscription?.id}
          assetSubscription={undefined}
          displayProps={{
            breadcrumbs: false,
            header: true,
            actions: true,
            viewVariant: ViewVariant.Tab,
          }}
          headerProps={{
            withLink: true,
            typographyProps: pageTabHeaderTypographyProps.title,
          }}
          onDelete={null}
        />
      </Stack>
    </PageTabContent>
  );
}
